module.exports = __webpack_public_path__ + "img/logo.9122832d.png";